































import Vue, {VueConstructor} from 'vue'
import {DateTime} from 'luxon'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    calendar: {months: DateTime[]},
  }
}>).extend({
  name: 'thirdStep',
  props: {
    scope: {} as () => {mailingId: string},
    mailingId: String
  },
  data () {
    return {
      sendNow: true,
      date: '',
      pickerOptions: {
        firstDayOfWeek: 1,
        format: 'HH:mm'
      }
    }
  },
  computed: {
  },
  methods: {
    prev () {
      this.$emit('prev')
    },
    next () {
      if (!this.sendNow && !this.date) {
        // @ts-ignore
        this.$message.warning(this.$t('labels.specify_date_and_time_of_sending'))
      } else {
        this.$emit('next')
      }
    },
    onInput (value: any) {
      if (value === null) {
        return;
      }

      let now = DateTime.local().toMillis()
      console.log('LOG: onInput -> now', now)
      if (value > now) {
        this.$emit('input', {date: this.date})
      } else {
        this.date = ''
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.not_possible_past_date_and_time'),
          type: 'warning'
        });
      }
    },
    submit () {
      this.$emit('submit')
    }
  },
  watch: {
    sendNow () {
      this.date = ''
      this.$emit('input', {date: this.date})
    }
  }
})
